export const resetFiltersValue = [
  {
    'id': 'floatingStateText',
    'value': ['NO DISPONIBLE', 'DISPONIBLE ', 'RESERVADO', 'SOL. NACIONALIZACIÓN'],
  },
];
